<template>
    <div class="label-lab-grown">
        {{ t('catalogue.lab_grown') }}
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.label-lab-grown {
    border-radius: 2px;
    padding: 4px 8px;
    background-color: $grey-200;
    font-family: $effra-font-stack;
    font-size: 11px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
    color: $slate;
    line-height: initial;
}
</style>
